import { DeleteOutlined } from '@ant-design/icons';
import { EssityColumnProps } from '@components/shared/paginatedEssityTable/GridHelper';
import PaginatedEssityTable from '@components/shared/paginatedEssityTable/PaginatedEssityTable';
import { SieveModel } from '@components/shared/paginatedEssityTable/SieveModels';
import { TableWithTitle } from '@components/shared/TableWithTitle';
import { ajaxByUser } from '@helper/api';
import { getEssityApiClient } from '@services/EssityApi';
import {
	AccountGetAllBusinessUsersOptionalParams,
	AccountUserDto,
} from '@services/src/models';
import { Button, Popconfirm, Tooltip } from 'antd';
import React from 'react';
import { gridStore } from 'stores/GridStore';

import { BusinessAccountsTableColumns } from './BusinessAccountsTableColumns';
import styles from './styles/BusinessAccountsManagement.module.less';

export const BusinessAccountsTable = () => {
	const tableColumns: EssityColumnProps<AccountUserDto>[] = [
		...BusinessAccountsTableColumns,
		{
			title: '',
			key: 'operation',
			fixed: 'right',
			width: 50,
			render: (item: AccountUserDto) => {
				return (
					<Popconfirm
						title="Are you sure to delete account?"
						okText="Yes"
						cancelText="No"
						placement="bottom"
						onConfirm={() => {
							ajaxByUser('Successfully deleted account.', () =>
								getEssityApiClient()
									.then((api) =>
										api.account.deleteMethod({
											userId: item.id,
										})
									)
									.then(() => {
										gridStore.searching.set(true);
									})
							);
						}}
					>
						<Tooltip title="Delete">
							<Button
								type="primary"
								shape="circle"
								size="small"
								icon={<DeleteOutlined />}
							/>
						</Tooltip>
					</Popconfirm>
				);
			},
		},
	];

	return (
		<TableWithTitle title="Business User Accounts">
			<PaginatedEssityTable<AccountUserDto>
				className={styles.table}
				columns={tableColumns}
				gridName="business-user"
				hidePersonalizationSettings={true}
				getRowKey={(r: AccountUserDto) => r.id!}
				getPagedResult={async (sieve: SieveModel, abortSignal) => {
					const parameters: AccountGetAllBusinessUsersOptionalParams = {
						page: sieve.page,
						pageSize: sieve.pageSize,
						sorts: sieve.sorts,
						abortSignal: abortSignal,
						filters: sieve.filters,
					};

					const api = await getEssityApiClient();
					return await api.account.getAllBusinessUsers(parameters);
				}}
			/>
		</TableWithTitle>
	);
};
